import React from 'react'

import { ExtendedPaletteColorName } from '../../../shared/MobiusColors'
import {
  type ColorToken,
  NeutralColorToken,
  SemanticColorToken,
} from '../../themes'
import { FoundationIcon } from '../FoundationIcon'
import type { Icon12 } from '../FoundationIcon/icons'
import { getColorValue, getNeutralColorVars, useTheme } from '../ThemeProvider'
import type { TimelineStatus } from './types'

type Props = {
  status: TimelineStatus
  iconOverride?: Icon12
}

export function StepIcon({ iconOverride, status }: Props) {
  let token: ColorToken = SemanticColorToken.Positive

  if (status === 'warning') {
    token = ExtendedPaletteColorName.SolLight
  } else if (status === 'error') {
    token = ExtendedPaletteColorName.Joule
  }

  if (iconOverride) {
    return <CustomizedIcon iconOverride={iconOverride} token={token} />
  }

  switch (status) {
    case 'incomplete': {
      return <Dot />
    }
    case 'ongoing': {
      return <FoundationIcon color={token} type="BubbleDot24" />
    }
    case 'complete': {
      return <FoundationIcon color={token} type="BubbleChecked24" />
    }
    case 'error': {
      return <FoundationIcon color={token} type="BubbleRemove24" />
    }
    case 'warning': {
      return <FoundationIcon color={token} type="Alert24" />
    }
    case 'paused': {
      return <FoundationIcon color={token} type="BubblePause24" />
    }
    default: {
      return <Dot />
    }
  }
}

function Dot() {
  return (
    <div
      css={{
        backgroundColor: getNeutralColorVars().bg3,
        borderRadius: '50%',
        height: 12,
        margin: 2,
        width: 12,
      }}
    />
  )
}

type CustomizedIconProps = {
  iconOverride: Icon12
  token: ColorToken
}

function CustomizedIcon({ iconOverride, token }: CustomizedIconProps) {
  const theme = useTheme()
  return (
    <div
      css={{
        alignItems: 'center',
        backgroundColor: getColorValue(token, theme),
        borderRadius: '50%',
        display: 'flex',
        height: 20,
        justifyContent: 'center',
        margin: 2,
        width: 20,
      }}
    >
      <FoundationIcon color={NeutralColorToken.Bg1} type={iconOverride} />
    </div>
  )
}
